import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { ProductPrice } from "../_models/product-price";
import { Product } from "../_models/product";
import { Globals } from "../globals";
import { ProductService } from "../_services/product.service";
import { ProductPriceAdjustments } from "../_models/product-price-adjustments";
import { MatSelectionListChange } from "@angular/material/list";
import { SelectionChange } from "@angular/cdk/collections";
import { MatSelectChange } from "@angular/material/select";

@Component({
  selector: "app-adjustment-price-form",
  templateUrl: "./adjustment-price-form.component.html",
  styleUrls: ["./adjustment-price-form.component.scss"],
})
export class AdjustmentPriceFormComponent implements OnInit {
  public adjustmentTypes = [
    { id: 1, name: "UBC", pointType: "NUC" },
    { id: 2, name: "UNOPreneur", pointType: "NUC" },
    { id: 3, name: "RS Reward", pointType: "RSR" },
    { id: 4, name: "Direct Selling Program", pointType: "DSP" },
  ];
  public adjustments: ProductPriceAdjustments[] = [];
  @Input() public price: ProductPrice;
  @Input() public product: Product;
  @Output() refresh = new EventEmitter();

  constructor(public globals: Globals, private productService: ProductService) {}

  public addAdjustment() {
    this.adjustments.push(new ProductPriceAdjustments());
  }

  public getPointType(id: number) {
    const pointTypes = this.adjustmentTypes.filter((adjType) => {
      return adjType.id == id;
    });
    return pointTypes.length > 0 ? pointTypes[0].pointType : "NUC";
  }

  adjustmentTypeChanged(adjustment: ProductPriceAdjustments, event) {
    console.log(event.target.value);
    adjustment.AdjustmentType = event.target.value;
    adjustment.pointType = this.getPointType(adjustment.AdjustmentType);
  }

  public ngOnInit(): void {
    if (this.price.ProductId) {
      this.productService.getPriceCountryAdjustments(this.price.ProductId, this.price.Origin).subscribe(
        (adjustments) => {
          this.adjustments = adjustments.map((adjustment) => {
            adjustment.pointType = this.getPointType(adjustment.AdjustmentType);
            return adjustment;
          });
          if (this.adjustments.length <= 0) {
            this.adjustments.push(new ProductPriceAdjustments());
          }
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }

  public savePriceAdjustment(adjustment: ProductPriceAdjustments) {
    adjustment.Origin = this.price.Origin;
    adjustment.ProductId = this.product.Id;
    adjustment.AdjustmentType = parseInt(adjustment.AdjustmentType.toString());
    console.log(adjustment);
    this.productService.saveProductPriceAdjustment(adjustment, this.product.Id).subscribe(
      (resp) => {
        console.log("resp: ", resp);
        this.refresh.emit(resp);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  public deleteAdjustment(adjustment: ProductPriceAdjustments) {
    this.productService.deleteProductPriceAdjustment(adjustment, this.product.Id).subscribe({
      next: (response) => {
        console.log(response);
        this.refresh.emit(response);
      },
      error: (err) => {
        console.error(err);
      },
    });
  }
}
